import { useCallback } from 'react'

import { useSelector } from 'react-redux'

import { makeSelectUser } from '@webapp/core/stores/global/selectors'
import { OrderDraftPreferredCreationFlows } from '@webapp/platform/iam/entities/enums/OrderDraftPreferredCreationFlowEnum'
import { useMutateOrderRequestFlowPreference } from '../../models/useMutateOrderRequestFlowPreference'

export const useSetOrderRequestFlowPreferencePresenter = () => {
  const currentUser = useSelector(makeSelectUser())

  const { setOrderDraftPreferredCreationFlow } =
    useMutateOrderRequestFlowPreference(currentUser.id)

  const setPreferrenceToClassicFlow = useCallback(() => {
    setOrderDraftPreferredCreationFlow(OrderDraftPreferredCreationFlows.CLASSIC)
  }, [setOrderDraftPreferredCreationFlow])

  const setPreferrenceToAIFlow = useCallback(() => {
    setOrderDraftPreferredCreationFlow(OrderDraftPreferredCreationFlows.AI)
  }, [setOrderDraftPreferredCreationFlow])

  return {
    commands: {
      setPreferrenceToClassicFlow,
      setPreferrenceToAIFlow,
    },
  }
}
